module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/be4e2bf9b94856d02aa68ae48fc7064c.png";